import React, { FC } from 'react';
import { EnterItModule } from 'types';
import { RegisterButton } from 'containers/pages/profession-item/components/intro/styled';
import {
    ButtonContainer,
    Container,
    Description,
    Lessons,
    ModuleTitle,
    ModuleTitleContainer,
    Title,
} from './styled';

export const EnterItModuleItem: FC<
    EnterItModule & { downloadTitle: string; setActive: () => void }
> = ({
    title,
    moduleTitle,
    lessonsCount,
    description,
    downloadTitle,
    setActive,
}) => (
    <Container>
        <ModuleTitleContainer>
            <ModuleTitle>{moduleTitle}</ModuleTitle>
        </ModuleTitleContainer>
        <Title variant={'h4'}>{title}</Title>
        <Description variant={'p2'}>{description}</Description>
        <ButtonContainer>
            <Lessons variant={'p3'}>{lessonsCount}</Lessons>
            <RegisterButton
                onClick={setActive}
                variant={'contained'}
                color={'primary-contrast'}
                size={'medium'}>
                {downloadTitle}
            </RegisterButton>
        </ButtonContainer>
    </Container>
);
